module.exports = __webpack_public_path__ + "sounds/5386564ac6312c56d2c102cb7c3c108b.mp3";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/sounds/select.mp3
// module id = 89
// module chunks = 0